import { render, staticRenderFns } from "./data-fetching-error.vue?vue&type=template&id=136f0f14"
import script from "./data-fetching-error.vue?vue&type=script&lang=js"
export * from "./data-fetching-error.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports